import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-card-detail',
  standalone: true,
  imports: [CommonModule, DataTablesModule],
  templateUrl: './card-detail.component.html',
  styleUrl: './card-detail.component.scss'
})
export class CardDetailComponent {
  isDisabled: boolean = false;
  @Input() Datas = {
    Title: null,
    Data: null as any
  };

  excelData = [];

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private activeModal: NgbActiveModal,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ExcelDump() {
    this.excelData = [];
    this.excelData = JSON.parse(JSON.stringify(this.Datas.Data));
    this.excelData.forEach(function (x: any) { delete x.SalaryMonthYear, delete x.DailyAttendanceInOutId, delete x.EmpMasterID, delete x.StateMasterId, delete x.BranchMasterID, delete x.DesignationMasterID, delete x.DepartmentMasterID, delete x.ShiftMasterID, delete x.RegionMasterID, delete x.RegionName, delete x.Leave, delete x.Regularization, delete x.AttendanceApprovalStatus, delete x.WorkingHour });
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'ExcelSheet.xlsx');
  }

  close() {
    this.activeModal.close();
  }
}
